(() => {
  const run = () => {
    const english = document.documentElement.lang.toLowerCase().startsWith('en');
    const localizedPath = (path) => (english ? `/en${path}` : path);
    const links = english
      ? [['/', 'Home'], ['/collections/all', 'Shop'], ['/pages/a-propos', 'About'], ['/pages/contact', 'Contact'], ['/pages/garantie-moosehaul', 'Warranty'], ['/pages/galerie', 'Gallery']]
      : [['/', 'Accueil'], ['/collections/all', 'Magasiner'], ['/pages/a-propos', 'À propos'], ['/pages/contact', 'Contact'], ['/pages/garantie-moosehaul', 'Garantie'], ['/pages/galerie', 'Galerie']];
    document.querySelectorAll('.mh2-mobile-menu').forEach((menu) => {
      if (menu.dataset.mh2PrimaryReady === 'true') return;
      menu.dataset.mh2PrimaryReady = 'true';
      menu.innerHTML = links.map(([href, label]) => `<a href="${localizedPath(href)}">${label}</a>`).join('');
    });

    // Collection, warranty, and gallery use the shared site header. Unlike
    // the Home and Contact sections, it has no inline click handler.
    const siteToggle = document.querySelector('.mh2-toggle[aria-controls="mh2-site-menu"]');
    const siteMenu = document.getElementById('mh2-site-menu');
    if (siteToggle && siteMenu && siteToggle.dataset.mh2ToggleReady !== 'true') {
      siteToggle.dataset.mh2ToggleReady = 'true';
      siteToggle.addEventListener('click', () => {
        const opening = siteToggle.getAttribute('aria-expanded') !== 'true';
        siteToggle.setAttribute('aria-expanded', String(opening));
        siteMenu.classList.toggle('is-open', opening);
      });
      siteMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
        siteToggle.setAttribute('aria-expanded', 'false');
        siteMenu.classList.remove('is-open');
      }));
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
})();
